import { Scene } from 'phaser'
import bag from '@/game/assets/board/bag.png'
import board from '@/game/assets/board/MapAliem.png'
import card from '@/game/assets/card/back.png'
import thudMp3 from '@/game/assets/thud.mp3'
import thudOgg from '@/game/assets/thud.ogg'

/*import Tred from '@/game/assets/token/red.png'
import Tgreen from '@/game/assets/token/green.png'*/
import proteger from '@/game/assets/token/proteger.png'
import capturer from '@/game/assets/token/capturer.png'
import deraciner from '@/game/assets/token/deraciner.png'
import utiliser from '@/game/assets/token/utiliser.png'
import relacher from '@/game/assets/token/relacher.png'
import favoriser from '@/game/assets/token/favoriser.png'
import limiter from '@/game/assets/token/limiter.png'
import bongeste from '@/game/assets/token/bongeste.png'
import quiz from '@/game/assets/token/quiz.png'
import kata from '@/game/assets/token/kata.png'


import caulerpe from '@/game/assets/token/caulerpe.png'
import ecrevisseblack from '@/game/assets/token/ecrevisseblack.png'
import ecrevisseblanche from '@/game/assets/token/ecrevisseblanche.png'
import ecureuilgris from '@/game/assets/token/ecureuilgris.png'
import ecureuilroux from '@/game/assets/token/ecureuilroux.png'
import frelon from '@/game/assets/token/frelon.png'
import griffesorciere from '@/game/assets/token/griffesorciere.png'
import posidonie from '@/game/assets/token/posidonie.png'
import statice from '@/game/assets/token/statice.png'
import abeille from '@/game/assets/token/abeille.png'

import papillon from '@/game/assets/token/papillon.png'
import tortue from '@/game/assets/token/tortue.png'
import cynips from '@/game/assets/token/cynips.png'
import palmier from '@/game/assets/token/palmier.png'
import cistude from '@/game/assets/token/cistude.png'
import chataignier from '@/game/assets/token/chataignier.png'

import jetons from '@/game/assets/jetons.png'
import jetonsac from '@/game/assets/jetonsac.png'
import quizz from '@/game/assets/quizz.png'
import scoreboard from '@/game/assets/scoreboard.png'
import empty from '@/game/assets/empty.png'
import message from '@/game/assets/message.png'
import param from '@/game/assets/param.png'
import classement from '@/game/assets/classement.png'
import croix from '@/game/assets/croix.png'
import regle from '@/game/assets/regle.png'

import accueilecran from '@/game/assets/accueilecran.png'
import boutonjouer from '@/game/assets/boutonjouer.png'
import boutonclassement from '@/game/assets/boutonclassement.png'
import logos from '@/game/assets/logos.png'
import titrejeu from '@/game/assets/titrejeu.png'
import axios from 'axios'

const DEFAULT_WIDTH = 1200;
const DEFAULT_HEIGHT = 900;
const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;
const scale = Math.min(screenWidth/DEFAULT_WIDTH,screenHeight/DEFAULT_HEIGHT);

export default class BootScene extends Scene {
  constructor () {
    super({ key: 'BootScene' })
  }

  preload () {
    this.load.image('bag', bag)
    //this.load.svg('board', board, { width: 967, height: 860 })
    this.load.image('board', board)
    this.load.image('card', card)


    /*this.load.image('Tred', Tred)
    this.load.image('Tgreen', Tgreen)*/

    this.load.image('proteger', proteger)
    this.load.image('capturer', capturer)
    this.load.image('deraciner', deraciner)
    this.load.image('utiliser', utiliser)
    this.load.image('relacher', relacher)
    this.load.image('favoriser', favoriser)
    this.load.image('limiter', limiter)
    this.load.image('bongeste', bongeste)
    this.load.image('quizz', quiz)
    this.load.image('kata', kata)

    this.load.image('abeille', abeille)
    this.load.image('frelon', frelon)
    this.load.image('ecureuilgris', ecureuilgris)
    this.load.image('ecureuilroux', ecureuilroux)
    this.load.image('ecrevisseblack', ecrevisseblack)
    this.load.image('ecrevisseblanche', ecrevisseblanche)
    this.load.image('caulerpe', caulerpe)
    this.load.image('griffesorciere', griffesorciere)
    this.load.image('posidonie', posidonie)
    this.load.image('statice', statice)

    this.load.image('papillon', papillon)
    this.load.image('tortue', tortue)
    this.load.image('cynips', cynips)
    this.load.image('palmier', palmier)
    this.load.image('cistude', cistude)
    this.load.image('chataignier', chataignier)

    this.load.image('jetons', jetons)
    this.load.image('jetonsac', jetonsac)
    this.load.image('quizzimg', quizz)
    this.load.image('scoreboard', scoreboard)
    this.load.image('empty', empty)
    this.load.image('message', message)
    this.load.image('param', param)
    this.load.image('classement', classement)
    this.load.image('regle', regle)
    this.load.image('croix', croix)
    this.load.image('accueilecran', accueilecran)
    this.load.image('boutonjouer', boutonjouer)
    this.load.image('logos', logos)
    this.load.image('titrejeu', titrejeu)



    // this.load.audio('thud', [thudMp3, thudOgg])
  }

  create () {
    /*console.log("boot");
    console.log(capturer);
    this.scene.start('PlayScene')*/
    this.cameras.main.centerOn(0,0);
    const div = document.createElement('div');
    div.style = 'width:'+screenWidth+'px;height:'+screenHeight+'px;position:initial;';
    div.innerHTML = "<div style='display:flex;justify-content:center;align-items:center;width:"+screenWidth+"px;height:"+screenHeight+"px;'><div style='width:"+screenWidth+"px;height:"+screenHeight+"px;;background-repeat:no-repeat;background-position: center;background-size: cover;background-image: url(\""+accueilecran+"\");color:#2D453D;display: flex;justify-content: center;align-items: center;flex-direction:column;'><img src='"+titrejeu+"' style='position: absolute;top:30px;width:40%;'><img id='playgame' src='"+boutonjouer+"' style='width: 20%;max-width: 479px;max-height: 210px;cursor:pointer;'><img id='showTable' src='"+boutonclassement+"' style='width: 20%;max-width: 479px;max-height: 210px;cursor:pointer;'></div></div><div style='background-image: url(\""+logos+"\");position:absolute;bottom:0;right:0;border-radius: 20px 0 0 0;height: 12%;width: 50%;background-repeat: no-repeat;background-position-x: right;background-size: cover;max-width: 630px;max-height: 90px;'></div></div>";
    this.containeraccueil = this.add.container(0, 0);
    this.elementaccueil = this.add.dom(0, 0, div);
    this.containeraccueil.add(this.elementaccueil);
    var t = this;
    document.getElementById('playgame').onclick = function(){
      t.scene.start('PlayScene')
    }

    this.divTablecontainer = this.add.container(0, 0);
    this.divTablecontainer.setVisible(false);
    const divnomequipe = document.createElement('div');
    divnomequipe.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
    //divnomequipe.innerHTML = "<div style='width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:930px;height:691px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+classement+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;position:relative;'><div id='Table' style='width:80%;'></div><img id='croix' style='position: absolute;right: -60px;top: 0;cursor:pointer;' src='"+croix+"'></div></div></div>";
    //italien
    divnomequipe.innerHTML = "<div style='width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:930px;height:691px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+classement+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;position:relative;'><div id='Table' style='width:80%;'></div><img id='croix' style='position: absolute;right: -60px;top: 0;cursor:pointer;' src='"+croix+"'></div></div></div>";
    //NON//divnomequipe.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:930px;height:691px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+classement+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;position:relative;'><div id='textenom' style='font-family: Inter;color: #FDE8CF;font-size: 50px;/* margin-left: 260px; */letter-spacing: 1px;margin-bottom: 20px;'>NOME SQUADRA : </div><input type='text' id='nomequipe' name='nomequipe' style='padding:0 30px;border-radius: 50px;border: 0;line-height: 90px;width: 500px;font-size: 60px;color: #36433e;font-family: Inter;background-color: #f7e9d5;'><div id='okname' style='font-size:30px;font-family:Jumbo;background-color:#9A2323;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Ok</div><div id='showTable' style='width:80%;'></div><img id='croix' style='position: absolute;right: -60px;top: 0;' src='"+croix+"'></div></div></div>";
    var elementnomequipe = this.add.dom(0, 0, divnomequipe);
    this.divTablecontainer.add(elementnomequipe);
    var url = "https://aliem-network.eu/mobiles.php?name=SimpleDataExt&op=get_game_score";
    //console.log(url);
    document.getElementById('showTable').onclick = function(){
      axios.get(url).then(response => (t.showTable(response.data)));
    };
    document.getElementById('croix').onclick = function(){
      t.divTablecontainer.setVisible(false);
  }
    
    /*this.boutonjouer = this.add.image(0, 0, 'boutonjouer');
    this.boutonjouer.setInteractive();
    this.boutonjouer.on("pointerdown", (p)=>{
      this.scene.start('PlayScene')
      //this.scene.game.backgroundColor.rgba = "rgba(50,68,61,1)";
    });*/
  }

  showTable(response){
    console.log(response);
    var place = 1;
    var score;
    var div = "<div style='height:480px;overflow-y:scroll;color:white;font-family:Inter';align-items: center;>";
    for (var i=0;i<response.classement.length;i++){
      if (score){
        if (score !=response.classement[i].score){
            place = i+1;
        }
      }
      div += "<div style='display:flex;background-color:#59786E;align-items: center;border-radius: 20px;padding: 15px 30px;margin-bottom: 20px;'>"
      div += "<div style='margin-right:20px;font-family:Grobold;text-align: center;color: #2D453D;font-size: 40px;padding-top: 10px;'>"+place+"</div>"
      div += "<div style='font-family:Inter;width:100%;text-align:left;font-size: 40px;display: flex;text-transform: uppercase;letter-spacing: 1px;width: 100%;-webkit-line-clamp: 1;-webkit-box-orient: vertical;display: -webkit-box;overflow-x: hidden;'>"+response.classement[i].nom+"</div>"
      div += "<div style='font-family:Grobold;padding-top: 10px;color: #DAB71C;font-size: 40px;'>"+response.classement[i].score+"</div>"
      div += "</div>";
      score = response.classement[i].score;
    }
    div += "</div>"
    //console.log(div);
    document.getElementById('Table').innerHTML = div;
    this.divTablecontainer.setVisible(true);
}
}
